module.exports = __webpack_public_path__ + "static/img/add_icon.4cad62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_icon.png
// module id = tmFK
// module chunks = 6